import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost, { downloadFileFromResponse } from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { selectProposalDashboardFilters } from "slices/proposalDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/proposal-dashboard/widgets/proposal-assignment";
const CSV_FILENAME = "Proposal Assignment.csv";
const PDF_FILENAME = "Proposal Assignment.pdf";

export const fetchProposalAssignment = createAsyncThunk(
  "proposalAssignment/fetch",
  async (_, { getState }) => {
    const filters = selectProposalDashboardFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);
    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);

export const exportProposalAssignmentCsv = () => async (dispatch, getState) => {
  try {
    const filters = selectProposalDashboardFilters(getState());
    const { data } = await localhost.get(`${BASE_URL}/export/csv`, {
      responseType: "blob",
      params: resolvePeriod(filters),
    });
    downloadFileFromResponse(data, CSV_FILENAME);
  } catch (err) {
    dispatch(showErrorModal(err));
  }
};

export const exportProposalAssignmentPdf = () => async (dispatch, getState) => {
  try {
    const filters = selectProposalDashboardFilters(getState());
    const { data } = await localhost.get(`${BASE_URL}/export/pdf`, {
      responseType: "blob",
      params: resolvePeriod(filters),
    });
    downloadFileFromResponse(data, PDF_FILENAME);
  } catch (err) {
    dispatch(showErrorModal(err));
  }
};
